/* iter-p3-x — Localised bookstore tagline map, single source of truth.
 *
 * Used by the bookstore hero (BookstoreLanding) and rippled into the
 * BookDetailModal footer so every product page carries the same brand
 * line in the reader's language.
 */

export const BOOKSTORE_TAGLINE_I18N = {
  en: 'Your Indie writing business, your way.',
  es: 'Tu negocio de escritura Indie, a tu manera.',
  fr: 'Votre entreprise d\u2019\u00e9criture indie, \u00e0 votre fa\u00e7on.',
  de: 'Dein Indie-Autorenbusiness, ganz nach deinen Regeln.',
  pt: 'Seu neg\u00f3cio de escrita indie, do seu jeito.',
  it: 'Il tuo business di scrittura indie, a modo tuo.',
  nl: 'Jouw indie schrijversbedrijf, op jouw manier.',
  zh: '\u4f60\u7684\u72ec\u7acb\u5199\u4f5c\u4e8b\u4e1a\uff0c\u7531\u4f60\u4e3b\u5bfc\u3002',
  ja: '\u3042\u306a\u305f\u306e\u30a4\u30f3\u30c7\u30a3\u30fc\u57f7\u7b46\u30d3\u30b8\u30cd\u30b9\u3092\u3001\u3042\u306a\u305f\u306e\u65b9\u5f0f\u3067\u3002',
  ko: '\uc790\uc2e0\uc758 \uc778\ub514 \uae00\uc4f0\uae30 \ube44\uc988\ub2c8\uc2a4\ub97c \ub2f9\uc2e0\uc758 \ubc29\uc2dd\uc73c\ub85c.',
  ar: '\u0645\u0634\u0631\u0648\u0639\u0643 \u0627\u0644\u0623\u062f\u0628\u064a \u0627\u0644\u0645\u0633\u062a\u0642\u0644\u060c \u0639\u0644\u0649 \u0637\u0631\u064a\u0642\u062a\u0643.',
  hi: '\u0906\u092a\u0915\u093e \u0907\u0902\u0921\u0940 \u0932\u0947\u0916\u0928 \u0935\u094d\u092f\u0935\u0938\u093e\u092f\uff0c \u0906\u092a\u0915\u0947 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947\u0964',
  ru: '\u0412\u0430\u0448 \u0438\u043d\u0434\u0438-\u043f\u0438\u0441\u0430\u0442\u0435\u043b\u044c\u0441\u043a\u0438\u0439 \u0431\u0438\u0437\u043d\u0435\u0441 \u2014 \u043f\u043e-\u0432\u0430\u0448\u0435\u043c\u0443.',
  tr: 'Kendi yolunda, kendi Indie yazarl\u0131k i\u015fin.',
  pl: 'Tw\u00f3j indie-pisarski biznes, po twojemu.',
  sv: 'Din indieskrivar-verksamhet, p\u00e5 ditt s\u00e4tt.',
  vi: 'Doanh nghi\u1ec7p vi\u1ebft l\u00e1ch indie c\u1ee7a b\u1ea1n, theo c\u00e1ch c\u1ee7a b\u1ea1n.',
  id: 'Bisnis menulis indie kamu, sesuai caramu.',
  th: '\u0e18\u0e38\u0e23\u0e01\u0e34\u0e08\u0e19\u0e31\u0e01\u0e40\u0e02\u0e35\u0e22\u0e19\u0e2d\u0e34\u0e19\u0e14\u0e35\u0e49\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13 \u0e43\u0e19\u0e41\u0e1a\u0e1a\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13.',
  he: '\u05d4\u05e2\u05e1\u05e7 \u05d4\u05db\u05ea\u05d9\u05d1\u05d4 \u05d4\u05d0\u05d9\u05e0\u05d3\u05d9 \u05e9\u05dc\u05da, \u05d1\u05d3\u05e8\u05da \u05e9\u05dc\u05da.',
};

export function taglineForLanguage(code) {
  if (!code) return BOOKSTORE_TAGLINE_I18N.en;
  const primary = String(code).split('-')[0].toLowerCase();
  return BOOKSTORE_TAGLINE_I18N[primary] || BOOKSTORE_TAGLINE_I18N.en;
}

export function taglineFromNavigator() {
  const nav = (typeof navigator !== 'undefined' && (navigator.language || (navigator.languages || [])[0])) || 'en';
  return taglineForLanguage(nav);
}
